module.exports = __webpack_public_path__ + "static/media/unknownCard.089f0b18.png";